<template>
    <base-input-textarea
        :input-name="placement.code"
        :input-rows="10"
        :input-value="value"
        :input-placeholder="placeholder"
        @input="updateText"
    />

    <p
        v-if="footer"
        v-html="footer"
        class="mt-6 cz3-footer"
    >
    </p>
</template>

<style lang="scss">
    #cz3 {
        .cz3-footer {
            a {
                @apply inline-block cursor-pointer hover:underline text-blue;
            }
        }
    }
</style>

<script>
    import BaseInputTextarea from './BaseInputTextarea.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            BaseInputTextarea,
        },

        props: {
            placement: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                value: '',
            };
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            placeholder() {
                return this.placement.custom?.['v-placeholder'];
            },

            footer() {
                return this.placement.custom?.['v-group-footer'];
            },
        },

        mounted() {
            const selected = this.viewController.selectedAtPlacement(this.placement.code);

            if (selected && selected.custom['v-text']) {
                this.value = selected.custom['v-text'];
            }
        },

        methods: {
            updateText(value) {
                this.value = value;

                this.viewController.commitCustomAttributes(this.placement.code, {
                    'v-text': value,
                });
            },
        },
    };
</script>
